import { VerificationRequestStatusLabels } from '@clearverify/constants';

import { VerificationRequestStatus } from 'src/api';

export const STEP_LABELS: Record<VerificationRequestStatus, string> = {
  [VerificationRequestStatus.EmployeeToRespond]: 'New Request',
  [VerificationRequestStatus.VerifierToRespond]: 'New Request',
  [VerificationRequestStatus.DeclinedByEmployee]:
    VerificationRequestStatusLabels[VerificationRequestStatus.DeclinedByEmployee],
  [VerificationRequestStatus.DeclinedByVerifier]:
    VerificationRequestStatusLabels[VerificationRequestStatus.DeclinedByVerifier],
  [VerificationRequestStatus.ReportCreated]:
    VerificationRequestStatusLabels[VerificationRequestStatus.ReportCreated],
  [VerificationRequestStatus.ReviewedByVerifier]:
    VerificationRequestStatusLabels[VerificationRequestStatus.ReviewedByVerifier],
};
